module.exports = __webpack_public_path__ + "static/media/icon-del-small.47bb9c70.svg";